<!-- =========================================================================================
    File Name: CardActions.vue
    Description: Card with actions
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div>
		<bread-crumbs
			:title="$t('Routing.Typology')"
			:subTitle="$t('general.SubtitleTypology')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<vs-button
			type="filled"
			class="g-btn-customize p-0 mb-6"
			icon-pack="feather"
			icon="icon-plus"
			@click.prevent="add"
		>
			<span v-text="$t('Add') + ' ' + $t('Routing.Typology')"></span>
		</vs-button>
		<div class="vx-row">
			<!-- All Actions -->
			<div
				class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3 md:mt-0 mb-base"
				v-for="(t, index) in listTipologies"
				:key="index"
			>
				<!-- CONTENT CARD - ICONS -->
				<vx-card v-if="true">
					<div>
						<h4 ref="nameTipology" contenteditable="false" class="g-table--title mb-4">{{ t.name }}</h4>
					</div>
					<p ref="descriptionTipology" class="mb-2 g-text" contenteditable="false">{{ t.description }}</p>
					<div class="flex mt-4 flex-wrap">
						<span class="flex mr-4" @click="save(index)">
							<feather-icon
								class="cursor-pointer"
								icon="SaveIcon"
								svgClasses="text-success stroke-current h-5 w-5"
							/>
							<span class="ml-2 g-text cursor-pointer">{{ $t("Save") }}</span>
						</span>
						<span class="flex mr-4 cursor-pointer" @click="setContenteditable(index)">
							<feather-icon
								class="cursor-pointer"
								icon="Edit2Icon"
								svgClasses="text-primary stroke-current h-5 w-5"
							/>
							<span class="ml-2 g-text cursor-pointer">{{ $t("Edit") }}</span>
						</span>
						<span class="flex mr-4" @click="openConfirmRemove(t)">
							<feather-icon
								class="cursor-pointer"
								icon="Trash2Icon"
								svgClasses="text-danger stroke-current h-5 w-5"
							/>
							<span class="ml-2 g-text cursor-pointer">{{ $t("Remove") }}</span>
						</span>
					</div>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
import moduleTipology from "@/store/tipology/moduleTipology.js";

export default {
	name: "Tipology",
	data() {
		return {
			tipologies: [],
			contenteditable: false,
			tipologySelected: null,
		};
	},
	computed: {
		listTipologies() {
			return this.$store.state.moduleTipology.tipologies;
		},
	},
	methods: {
		focusInput() {
			this.$refs.descriptionTipology[0].focus();
			//this.$refs.descriptionTipology[1].setSelectionRange(4, 4);
			let range = document.createRange();
			let sel = window.getSelection();

			range.setStart(this.$refs.descriptionTipology[0].childNodes[0], 4);
			range.collapse(true);
		},
		closeCardAnimationDemo(card) {
			card.removeRefreshAnimation(3000);
		},
		setContenteditable(index) {
			let currentState = this.$refs.nameTipology[index].contentEditable;
			if (currentState == "true") {
				this.changeContent(index, false);
			} else {
				this.changeContent(index, true);
				this.$refs.nameTipology[index].focus();
			}
			this.$refs.nameTipology[index].classList.toggle("editable");
			this.$refs.descriptionTipology[index].classList.toggle("editable");
		},
		changeContent(index, opc) {
			this.$refs.nameTipology[index].setAttribute("contenteditable", opc);
			this.$refs.descriptionTipology[index].setAttribute("contenteditable", opc);
		},
		openConfirmRemove(tipology) {
			this.tipologySelected = tipology;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text:
					this.$t("TextDeleteTipology") + ` "${this.tipologySelected.name}"? ` + this.$t("TextAccepContinue"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.remove,
			});
		},
		async add() {
			const newTipology = {
				description: this.$t("NewTipology.description"),
				name: this.$t("NewTipology.name"),
				company_id: 1,
			};
			const fetch = await this.$store.dispatch("moduleTipology/addTypology", newTipology);
			const data = fetch.data;
			this.$vs.notify({
				color: "success",
				title: this.$t("TitleConfirmTipologyCreate"),
				text: this.$t("TextConfirmTipologyCreate"),
			});
		},
		async remove(tipology) {
			const fetch = await this.$store.dispatch("moduleTipology/removeTipology", this.tipologySelected.id);
			this.$vs.notify({
				color: "success",
				title: this.$t("TitleConfirmTipologyDelete"),
				text: this.$t("TextConfirmTipologyDelete"),
			});
		},
		async save(index) {
			const tipologyUpdate = {...this.listTipologies[index]};
			tipologyUpdate.description = this.$refs.descriptionTipology[index].innerText.trim();
			tipologyUpdate.name = this.$refs.nameTipology[index].innerText.trim();
			const fetch = await this.$store.dispatch("moduleTipology/updateTipology", tipologyUpdate);
			const data = fetch.data;
			this.$vs.notify({
				color: "success",
				title: this.$t("TitleConfirmTipologyUpdate"),
				text: this.$t("TextConfirmTipologyUpdate"),
			});
			this.changeContent(index, false);
			this.$refs.nameTipology[index].classList.remove("editable");
			this.$refs.descriptionTipology[index].classList.remove("editable");
		},
	},
	created() {
		if (!moduleTipology.isRegistered) {
			this.$store.registerModule("moduleTipology", moduleTipology);
			moduleTipology.isRegistered = true;
		}
		this.$store.dispatch("moduleTipology/fetchTypology");
	},
	mounted() {
		this.tipologies = this.$store.state.moduleTipology.tipologies;
	},
};
</script>

<style scoped>
.card-margin {
	margin-top: 20px;
}

.editable:after {
	content: "\270E";
	display: inline-block;
	width: 20px;
	height: 20px;
	margin: 0 6px 0 0;
}
</style>
